export default "__VITE_ASSET__hLJ10oOW__"